/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Swedish (sv) string table · skin-concerns.html
   English is the source of truth in the HTML; this file supplies the
   Swedish counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-sv.js.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.sv = window.TD_I18N.sv || {};
  Object.assign(window.TD_I18N.sv, {

    /* ── Page header ── */
    'concerns.headLabel': 'Hitta din formel',
    'concerns.headTitle': 'Börja med det som<br><em>besvärar dig.</em>',
    'concerns.headSub': 'Fem serum, fem biologiska mål. Börja med det behov som betyder mest för dig, så väljer rätt serum oftast sig självt.',

    /* ── Jump bar ── */
    'concerns.jumpLabel': 'Hoppa till',
    'concerns.jumpFirmness': 'Fasthet',
    'concerns.jumpBrightness': 'Lyster',
    'concerns.jumpHydration': 'Fukt',
    'concerns.jumpFineLines': 'Fina linjer',
    'concerns.jumpDarkSpots': 'Mörka fläckar',
    'concerns.jumpTexture': 'Struktur',
    'concerns.jumpAcneScars': 'Aknärr',
    'concerns.jumpDullness': 'Glåmighet',

    /* ── Reusable row labels ── */
    'concerns.startWith': 'Börja med',
    'concerns.shopRoutine': 'Handla denna rutin →',
    'concerns.nameC': 'Serum C — <em>Lyster</em>',
    'concerns.nameA': 'Serum A — <em>Förnyelse</em>',
    'concerns.nameO': 'Serum O — <em>Cellulärt</em>',
    'concerns.nameM': 'Serum M — <em>Fukt</em>',
    'concerns.nameR': 'Serum R — <em>Klarhet</em>',
    'concerns.rolePrimaryDay': 'Primär · Dag',
    'concerns.rolePrimaryNight': 'Primär · Natt',
    'concerns.rolePrimaryDayNight': 'Primär · Dag + Natt',
    'concerns.roleLayerDay': 'Lager · Dag',
    'concerns.roleLayerNight': 'Lager · Natt',

    /* ── Concern 01 · Firmness ── */
    'concerns.c1Num': 'Behov 01',
    'concerns.c1Title': 'Fasthet<br><em>& elasticitet.</em>',
    'concerns.c1Lede': 'Käklinjen mjuknar. Kinderna förlorar sitt lyft. Huden börjar sjunka snarare än hålla. Det är det första synliga tecknet på att produktionen av kollagen och elastin har avtagit, och det enklaste att vända på cellnivå.',

    /* ── Concern 02 · Brightness ── */
    'concerns.c2Num': 'Behov 02',
    'concerns.c2Title': 'Lyster<br><em>& solskador.</em>',
    'concerns.c2Lede': 'Huden ser trött ut även när du inte är det. Ofta är det kumulativt: UV, föroreningar, stress, minskad cellulär energi. Vitamin C är den mest studerade topiska ingrediensen för lyster. Serum O går längre och matar mitokondrierna direkt, de celler som producerar energi.',

    /* ── Concern 03 · Hydration ── */
    'concerns.c3Num': 'Behov 03',
    'concerns.c3Title': 'Uttorkning<br><em>& barriärförlust.</em>',
    'concerns.c3Lede': 'Torr hud handlar inte om mer fuktkräm. Det handlar om en bruten lipidbarriär. De flesta fuktkrämer är 65-85% vatten plus alkohol och konserveringsmedel, vilket paradoxalt nog torkar ut huden ytterligare. Serum M bygger upp barriären inifrån med hjälp av hudidentiska lipider.',

    /* ── Concern 04 · Fine lines ── */
    'concerns.c4Num': 'Behov 04',
    'concerns.c4Title': 'Fina linjer<br><em>& rynkor.</em>',
    'concerns.c4Lede': 'Ytliga linjer från ansiktsuttryck, djupare veck från tid och sol. Cellförnyelsen avtar med åldern; gamla keratinocyter stannar kvar längre; strukturen blir lidande. Retinol driver förnyelse och slätar ut ytan; vitamin C bygger upp strukturen under.',

    /* ── Concern 05 · Dark spots ── */
    'concerns.c5Num': 'Behov 05',
    'concerns.c5Title': 'Mörka fläckar<br><em>& pigmentering.</em>',
    'concerns.c5Lede': 'Solskador, hormonella förändringar och postinflammatoriska märken koncentrerar pigment i ojämna fläckar. Vitamin C hämmar enzymet (tyrosinas) som driver pigmentproduktionen; resveratrol neutraliserar de fria radikaler som utlöser den.',

    /* ── Concern 06 · Texture ── */
    'concerns.c6Num': 'Behov 06',
    'concerns.c6Title': 'Ojämn<br><em>struktur.</em>',
    'concerns.c6Lede': 'Strävare partier, synliga porer, en ojämn yta som smink lägger sig på snarare än slätar ut. Det är nästan alltid ett problem med cellförnyelse: gamla, förtjockade hudceller som stannar kvar längre än de borde. Retinol påskyndar cykeln.',

    /* ── Concern 07 · Post-acne ── */
    'concerns.c7Num': 'Behov 07',
    'concerns.c7Title': 'Efter akne<br><em>& ärrbildning.</em>',
    'concerns.c7Lede': 'Långt efter att utbrottet är borta är märket ofta kvar. Resveratrol minskar postinflammatorisk pigmentering och stöttar huden när den slutför den reparation den påbörjat. Kombinera med Serum A på natten för cellförnyelse som påskyndar att märket bleknar.',

    /* ── Concern 08 · Dullness / mature ── */
    'concerns.c8Num': 'Behov 08',
    'concerns.c8Title': 'Glåmig hud <em>&amp; minskad elasticitet.</em>',
    'concerns.c8Lede': 'När huden mognar saktar de system ner som håller den lysande och spänstig. Ytans klarhet bleknar och elasticiteten mjuknar. Serum O förnyar och återupplivar mogen hud på cellnivå och stöttar den lyster och spänst som avtar med åldern.',

    /* ── Not sure CTA ── */
    'concerns.unsureLabel': 'Väljer du fortfarande?',
    'concerns.unsureTitle': 'Välj inte. Prova alla fem.',
    'concerns.unsureBody': 'Discovery Kit innehåller fickstora versioner av varje serum och en tryckt guide. Det är det snabbaste sättet att lära sig vilket av dina behov som svarar på vilken formel: på din hud, inte i teorin.',
    'concerns.unsureBtn': 'Skaffa Discovery Kit',

    /* ── Footer (page-specific extra) ── */
    'concerns.ftLearnRonlan': 'Om Dr. Ronlán',

    /* ── Theme-only: Concern 08 alt framing (fatigue / low energy) ── */
    'concerns.c8TitleFatigue': 'Trötthet<br><em>& låg energi.</em>',
    'concerns.c8LedeFatigue': 'Hud som ser trött ut handlar inte alltid om det som syns på ytan. Det handlar om det som producerar den. Mitokondriell produktion avtar med åldern, och med den cellens förmåga att bilda kollagen och reparera skador. Serum O matar systemet direkt.',

    /* ── Theme-only: application banner (conditional) ── */
    'concerns.appDividerLabel': 'I praktiken',
    'concerns.appDividerQuote': 'Två droppar, morgon och kväll. Den hud du har, omhändertagen.',

    /* ── Theme-only: shortened unsure body (no printed guide) ── */
    'concerns.unsureBodyShort': 'Discovery Kit innehåller fickstora versioner av varje serum. Det är det snabbaste sättet att lära sig vilket av dina behov som svarar på vilken formel: på din hud, inte i teorin.'

  });
})();
